import type { MEDIA_SORT_MENU_NAME_CONFIG } from '../constants/sort-menu-config'

export type SortMenuConfigItem = keyof typeof MEDIA_SORT_MENU_NAME_CONFIG

export enum SortMenuType {
  media = 'media',
  persona = 'persona',
}
